<template>
  <div class="contents">
    <div class="layout">

      <div class="page-top">
        <h2>{{ getMenuLabel() }} 관리</h2>
        <div class="breadcrumbs">
          <span>컨텐츠 관리</span>
          <span class="color-black">{{ getMenuLabel() }} 관리</span>
        </div>
      </div>

      <div class="white-panel mt30 pt30 pb30">
        <div class="search-panel">
          <table>
            <colgroup>
              <col style="width:150px;">
              <col>
            </colgroup>
            <tbody>
            <tr>
              <th>검색어</th>
              <td>
                <div class="input-search">
                  <input v-model="searchQuery" @keyup.enter="fetchItems" type="text" name="search-input" placeholder="검색어 입력">
                  <i @click="fetchItems" class="button-search" style="cursor: pointer;"><img src="@/assets/images/ico/ico_search.svg" alt=""/></i>
                </div>
              </td>
            </tr>
            <tr v-if="articleType === 'exhibitions'">
              <th>지도 좌표</th>
              <td>
                <!--
                  checkbox-type1 은 label 을 20x20 체크박스 그림으로 바꾸는 클래스라(테이블 헤더의 '체크' 처럼)
                  안에 글자를 넣으면 화면에서 사라진다. 이름표는 밖에 따로 둔다.
                -->
                <span class="checkbox-type1">
                  <input v-model="unmappedOnly" @change="fetchItems" type="checkbox" id="unmapped-only">
                  <label for="unmapped-only">체크</label>
                </span>
                <label for="unmapped-only" class="coord-filter-label">좌표 미확보만 보기</label>
                <!-- 필터가 켜져 있으면 목록 자체가 미확보 건만이라, 그 상태에서 "표시됨 0건" 이라고 쓰면 사실과 다르게 읽힌다 -->
                <span class="coord-summary" v-if="unmappedOnly">좌표 미확보 {{ items.length }}건</span>
                <span class="coord-summary" v-else>지도에 표시됨 {{ mappedCount }}건 · 좌표 미확보 {{ items.length - mappedCount }}건</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="list-top mt50">
        <h3></h3>
        <div class="control-group">
          <div class="btn-group">
            <button @click="deleteItems" type="button" class="delete-button">삭제</button>
            <button @click="addArticle" type="button" class="navy-button add-button">등록</button>
          </div>
        </div>
      </div>

      <div class="white-panel mt20">
        <div class="table-wrap">
          <div class="scroll-box">
            <table class="table-type1">
              <!-- 컬럼 비율 설정 -->
              <colgroup>
                <col style="width: 5%;"> <!-- 체크 -->
                <col style="width: 5%;"> <!-- NO -->
                <col> <!-- 제목 -->
                <col style="width: 20%;"> <!-- 기간 -->
                <col style="width: 10%;"> <!-- 공개여부 -->
                <col style="width: 10%;"> <!-- Home 전시-->
                <col v-if="articleType === 'exhibitions'" style="width: 8%;"> <!-- 좌표 -->
                <col style="width: 15%;"> <!-- 등록일 -->
                <col style="width: 15%;"> <!-- 등록일 -->
              </colgroup>
              <thead>
              <tr>
                <th>
									<span class="checkbox-type1">
										<input @click="toggleAllCheck" type="checkbox" id="allchk">
										<label for="allchk">체크</label>
									</span>
                </th>
                <th>NO</th>
                <th>제목</th>
                <th>기간</th>
                <th>공개여부</th>
                <th>Home 전시</th>
                <th v-if="articleType === 'exhibitions'">좌표</th>
                <th>등록일</th>
                <th>변경일</th>
              </tr>
              </thead>
              <tbody ref="tbodyRef">
              <tr v-for="(item, index) in items" :key="index" :class="{'bg-highlight': item.isHomeVisible,'bg-hidden': item.isHidden}">
                <td>
                    <span class="checkbox-type1">
                        <input v-model="selectedItems" :id="item.uuid" type="checkbox" :value="item.uuid">
                        <label :for="item.uuid">체크</label>
                    </span>
                </td>
                <td>{{ index+1 }}</td>
                <td>
                  <router-link :to="{ name: 'ArticleDetail', params: { articleType: item.articleType, uuid: item.uuid } }"
                               style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: inline-block; max-width: 100%;">
                    {{ item.title }}
                  </router-link>
                </td>
                <td>{{ getPeriodRange(item) }}</td>
                <td>
                  <select v-model="item.isHidden" @change="updateVisibility(item)"
                          :class="{'bg-hidden': item.isHidden}"
                  >
                    <option :value="false">공개</option>
                    <option :value="true">비공개</option>
                  </select>
                </td>
                <td>
                  <select v-model="item.isHomeVisible" @change="updateVisibility(item)"
                          :class="{'bg-highlight': item.isHomeVisible}"
                  >
                    <option :value="true">공개</option>
                    <option :value="false">비공개</option>
                  </select>
                </td>
                <td v-if="articleType === 'exhibitions'">
                  <span :class="isMapped(item) ? 'coord-cell--ok' : 'coord-cell--none'">
                    {{ isMapped(item) ? '있음' : '미확보' }}
                  </span>
                </td>
                <td>{{ item.createdAt }}</td>
                <td>{{ item.updatedAt }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue';
import {apiClient} from '@/services/auth-header';
import {useRoute} from 'vue-router';
import router from '@/router';
import {getGenderText} from '@/common/enum-converter';

const route = useRoute();
const items = ref([]);
const selectedItems = ref([]);
const searchQuery = ref('');
const articleType = ref(route.params.articleType);
const API_URL = '/contents';

const getMenuLabel = () => {
  if (articleType.value === 'exhibitions') {
    return '전시';
  } else if (articleType.value === 'events') {
    return '이벤트'
  }
  return '뉴스'
}

const getPeriodRange = (item) => {
  return `${item.periodFrom} ~ ${item.periodTo}`;
};

const updateVisibility = async (item) => {
  try {
    await apiClient.put(API_URL + `/articles/${articleType.value}/${item.uuid}/visibility`, {
      isHidden: item.isHidden,
      isHomeVisible: item.isHomeVisible,
    });
  } catch (error) {
    console.error('❌ 업데이트 실패', error)
    alert('변경 중 오류가 발생했습니다.')
  }
}


// 좌표 미확보 필터 (mimio#32 3a) — 보정 대상이 눈에 보여야 담당자가 고칠 수 있다
const unmappedOnly = ref(false);
const isMapped = (item) => item.latitude != null && item.longitude != null;
const mappedCount = computed(() => items.value.filter(isMapped).length);

const fetchItems = async () => {
  // unmappedOnly 는 전시에만 있는 개념 — 이벤트·뉴스 요청에는 안 붙인다
  const params = {q: searchQuery.value};
  if (articleType.value === 'exhibitions' && unmappedOnly.value) {
    params.unmappedOnly = true;
  }
  await apiClient.get(API_URL + `/articles/${articleType.value}`, {params})
  .then(response => {
    items.value = response.data;
  })
  .catch(error => {
    console.error('Error:', error);
  });
};

const deleteItems = async () => {
  if(selectedItems.value.length === 0){
    alert('삭제할 항목을 선택하세요.');
    return;
  }
  if(confirm('삭제 하시겠습니까?')){
    try {
      const response = await apiClient.delete(API_URL + `/articles/${articleType.value}`, { data: selectedItems.value });
      if (response.status === 200) {
        alert('삭제되었습니다.')
        selectedItems.value = [];
        await fetchItems();
      }
    } catch (error) {
      console.error('Error deleting items:', error);
    }
  }
};

const search = () => {
  fetchItems();
};

const addArticle = () => {
  router.push(`/content/article/${articleType.value}`);
};

const toggleAllCheck = (event) => {
  if (event.target.checked) {
    selectedItems.value = items.value.map(item => item.uuid);
  } else {
    selectedItems.value = [];
  }
};

onMounted(async () => {
  await fetchItems();
});

</script>

<style scoped>
/* 좌표 미확보 표시 (mimio#32 3a) */
.coord-filter-label {
  margin-left: 8px;
  font-size: 14px;
  cursor: pointer;
  vertical-align: middle;
}

.coord-summary {
  margin-left: 14px;
  font-size: 13px;
  color: #777;
}

.coord-cell--ok {
  color: #2e7d32;
}

.coord-cell--none {
  color: #c0392b;
  font-weight: 600;
}
</style>
